"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentFrequency = void 0;
var PaymentFrequency;
(function (PaymentFrequency) {
    PaymentFrequency["MENSUAL"] = "Mensual";
    PaymentFrequency["ANUAL"] = "Anual";
})(PaymentFrequency || (exports.PaymentFrequency = PaymentFrequency = {}));
//# sourceMappingURL=payment-frequency.js.map